/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NameType } from '../../models/name-type';

export interface ExternalTestStringLength$Params {
      body: {
'msg': string;
}
}

export function externalTestStringLength(http: HttpClient, rootUrl: string, params: ExternalTestStringLength$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'codePoints': number;
'message': NameType;
}>> {
  const rb = new RequestBuilder(rootUrl, externalTestStringLength.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'codePoints': number;
      'message': NameType;
      }>;
    })
  );
}

externalTestStringLength.PATH = '/external/test-string-length';
